import React from 'react';
import { Button as ButtonStyled, ButtonProps } from 'react-bootstrap';
import './button.scss';

interface CustomButtonProps extends Omit<ButtonProps, 'children'> {
  children: React.ReactNode;
}

export default function Button({ children, ...props }: CustomButtonProps) {
  return <ButtonStyled {...props}>{children}</ButtonStyled>;
}
